import { Resources } from 'constants/resources';

import { useGoBack } from 'hooks/useGoBack';
import { useStagedDelete } from 'hooks/useStagedDelete';
import { queryClient } from 'providers/queryClient';
import { CancelButton } from 'shared/mui/Buttons';
import { CardHeader } from 'shared/mui/Card';
import { Dialog } from 'shared/mui/Dialogs';
import { DeleteStageDialogDenyReason } from 'shared/mui/Dialogs/DeleteStageDialog/DeleteStageDialogDenyReason';
import { DeleteStageDialogForm } from 'shared/mui/Dialogs/DeleteStageDialog/DeleteStageDialogForm';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { MethodLogo } from 'types/embedded/methodLogo';

import { StyledBox } from './MethodLogosDeleteDialog.styled';

type MethodLogosDeleteDialogProps = {
  record?: MethodLogo;
  open: boolean;
  onClose: () => void;
};

export const MethodLogosDeleteDialog: React.FC<MethodLogosDeleteDialogProps> = ({
  record,
  open,
  onClose,
}) => {
  const { goBack } = useGoBack();
  const closeAndReturn = () => {
    onClose();
    goBack();
  };
  const { deleteOneRecord, denyDeleteReason, stage } = useStagedDelete({
    record,
    onSuccess: async () => {
      closeAndReturn();
      await queryClient.refetchQueries({ queryKey: [Resources.MethodLogos] });
    },
  });

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <StyledBox>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title="Удаление логотипа"
          titleSize="smallBold"
        />
        <DeleteStageDialogForm
          deleteOneRecord={deleteOneRecord}
          details={
            <Typography>
              Логотип <TypographyBold fontSize={16} text={record?.name || ''} /> будет удален без
              возможности восстановления.
            </Typography>
          }
          onClose={onClose}
          open={true}
          stage={stage}
        >
          <DeleteStageDialogDenyReason reason={denyDeleteReason}>
            <CancelButton
              label="Вернуться к списку логотипов методов"
              onClick={closeAndReturn}
              variant="outlined"
            />
          </DeleteStageDialogDenyReason>
        </DeleteStageDialogForm>
      </StyledBox>
    </Dialog>
  );
};
